import { useState } from 'react'

import { Box, Button, Section, Skeleton } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useHiringStages } from 'modules/ats/hooks/hiringStages/useHiringStages'

import { EditHiringPipelinesSidepanel } from './EditHiringPipelinesSidepanel'
import { StageCards } from './StageCards'

export const HiringPipelinesSettings = () => {
  const [editHiringPipeline, setEditHiringPipeline] = useState(false)
  const { loading, hiringStages } = useHiringStages()

  return (
    <Box>
      <Section
        illustration="automations"
        title={i18n.t('ats.hiring_pipelines.settings.title')}
        description={i18n.t('ats.hiring_pipelines.settings.description')}
      >
        <Box alignSelf="flexEnd">
          <Button
            aria-label={i18n.t('ats.hiring_pipelines.settings.edit')}
            type="negative"
            onClick={() => setEditHiringPipeline(true)}
          >
            {i18n.t('ats.hiring_pipelines.settings.edit')}
          </Button>
        </Box>
      </Section>

      <Box flexDirection="row" flexGrow paddingX="s64" paddingY="s32" width="full">
        {loading ? (
          <HiringStagesCardsSkeleton />
        ) : (
          <>
            <StageCards stages={hiringStages} />
            {editHiringPipeline && (
              <EditHiringPipelinesSidepanel
                stages={hiringStages}
                onClose={() => setEditHiringPipeline(false)}
              />
            )}
          </>
        )}
      </Box>
    </Box>
  )
}

const HiringStagesCardsSkeleton = () => {
  return <Skeleton height="s120" width="full" />
}
